import React from 'react';
import PropTypes from 'prop-types';
import {
    Drawer,
    Paragraph,
    Button,
    ButtonToolbar,
    ButtonGroup,
    Checkbox,
    Form,
    FormControl,
    FormGroup,
    ControlLabel,
    HelpBlock,
    DatePicker,
    InputPicker,
    Row,
    Col,
    Panel,
    InputGroup,
    InputNumber,
    Input,
    Divider,
    IconButton
} from 'rsuite';
import RFormControl from '../../../componentsGeneral/Rsuite/Form/RFormControl';
import { lettersNumbersDashesInputMask, numbersInputMask, lettersNumbersDashesSpacesInputMask, limitCharacterLength, textNumbersSymbolsInputmask } from '../../../../resources/logic/inputMasks';
import RButtonSmall from '../../../componentsGeneral/Rsuite/Button/RButtonSmall';
import * as moment from 'moment'
import { convertNanToZero } from '../../../../resources/logic/functions';
import CloseIcon from '@rsuite/icons/Close';
import debounceClick from '../../../../resources/logic/useability';
import DebouncedButton from '../../../componentsGeneral/Rsuite/Button/DebouncedButton';


const styles = {
    width: '100%'
};

function limitNumberToExistingUnitsValue(e, locationitem, item, originalProps) {
    var itemIndex = originalProps[item.SkuID].findIndex(({ SkuWarehouseLocationID }) => SkuWarehouseLocationID === locationitem['SkuWarehouseLocationID']);

    var nonNegativeValue
    nonNegativeValue = numbersInputMask(e)

    try {
        var limitValue = originalProps[item.SkuID][itemIndex]['Units']
    }
    catch (e) {
        var limitValue = 0
    }

    if (nonNegativeValue <= limitValue) {
        return nonNegativeValue
    }
    else {
        window.alert('Must not be greater than ' + limitValue.toString())
        return limitValue
    }
}

function limitNumberToExistingValue(e, locationitem, item, originalProps) {
    var itemIndex = originalProps[item.SkuID].findIndex(({ SkuWarehouseLocationID }) => SkuWarehouseLocationID === locationitem['SkuWarehouseLocationID']);

    var nonNegativeValue
    nonNegativeValue = numbersInputMask(e)

    try {
        var limitValue = originalProps[item.SkuID][itemIndex]['Cases']
    }
    catch (e) {
        var limitValue = 0
    }

    if (nonNegativeValue <= limitValue) {
        return nonNegativeValue
    }
    else {
        window.alert('Must not be greater than ' + limitValue.toString())
        return limitValue
    }
}

// function limitNumberToExistingValue(e, item) {
//     var nonNegativeValue
//     nonNegativeValue = numbersInputMask(e)

//     try {
//         var limitValue = item['CasesReceived'] - item['CasesLoaded']
//     }
//     catch (e) {
//         var limitValue = 0
//     }

//     if (nonNegativeValue <= limitValue) {
//         return nonNegativeValue
//     }
//     else {
//         window.alert('Must not be greater than ' + limitValue.toString())
//         return limitValue
//     }
//     // var newString = null

//     // if (inputString == null || typeof (inputString) == 'undefined') {

//     // }
//     // else {
//     //     var stripString = inputString.trim().replace(/[|&;$%"'`\[\]#!^*~<>()+=]/g, '') //Add unwanted characters inside []
//     //     var newString = "'" + stripString + "'"
//     // }
//     // return e.target.value
// }

// style={{ overflowX: 'hidden!important' }} 

const mountRef = React.createRef();

const BuildLoadDrawer = ({ onChange, onChangeLoad, onChangeLocation, onClickRemoveFromAdd, totalUnitsNumber, totalRecoveredNum, totalPalleteNum, show, placement, confirm, close, remove, state, ...props }) => (

    <Drawer show={state.showBuildLoadDrawer} onHide={close} placement={placement} style={props.isMobile ? { width: '350px' } : { width: '800px' }}    >
        <Drawer.Header>
            <Drawer.Title>Build Load</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body > <div ref={mountRef}>

            {/* <Row style={{ marginBottom: '15px' }}>
                <Col md={24} sm={24}>
                    <FormGroup>
                        <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                            <Input readOnly value={'Total Units: ' + totalUnitsNumber} />
                        </InputGroup>
                        <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                            <Input readOnly value={'Total Cases: ' + totalRecoveredNum} />
                        </InputGroup>
                        <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                            <Input readOnly value={'Total Pallets: ' + totalPalleteNum} />
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row> */}

            <Panel bordered style={{ marginBottom: '15px' }}>
                <Row>
                    <Col md={24} sm={24}>
                        <FormGroup >
                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Pickup Date:</InputGroup.Addon>
                                <DatePicker
                                    container={() => mountRef.current} oneTap style={styles} placeholder={(state.NewLoadData.PickupDate === null ? 'Pickup Date' : moment(state.NewLoadData.PickupDate).format('YYYY-MM-DD'))} onChange={(e) => onChangeLoad(e, 'PickupDate')} />
                            </InputGroup>
                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Delivery Date:</InputGroup.Addon>
                                <DatePicker
                                    container={() => mountRef.current} oneTap style={styles} placeholder={(state.NewLoadData.DeliveryDate === null ? 'Delivery Date' : moment(state.NewLoadData.DeliveryDate).format('YYYY-MM-DD'))} onChange={(e) => onChangeLoad(e, 'DeliveryDate')} />
                            </InputGroup>

                            <div style={{ marginBottom: '15px', width: '100%' }}>
                                <InputPicker preventOverflow
                                    container={() => mountRef.current}
                                    block
                                    creatable
                                    placeholder={'Destination...'}
                                    value={state.NewLoadData.Destination}
                                    // onChange={(e, value, label) => { onChangeDestination(e, value, label) }}
                                    onChange={(e) => { onChangeLoad(e, 'Destination') }}
                                    data={props.InventoryDestinationData}
                                    cleanable={true}
                                />
                            </div>

                        </FormGroup>
                    </Col>
                    <Col md={12} sm={24}>
                        <FormGroup >

                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Carrier:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.Carrier} onChange={(e) => { onChangeLoad(e, 'Carrier') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>

                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Trailer #:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.Trailer} onChange={(e) => { onChangeLoad(e, 'Trailer') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>



                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>MC #:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.MC} onChange={(e) => { onChangeLoad(e, 'MC') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>
                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>DOT #:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.DOT} onChange={(e) => { onChangeLoad(e, 'DOT') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>
                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Driver:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.Driver} onChange={(e) => { onChangeLoad(e, 'Driver') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>



                        </FormGroup>
                    </Col>
                    <Col md={12} sm={24}>
                        <FormGroup >


                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>BOL #:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.BOL} onChange={(e) => { onChangeLoad(e, 'BOL') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>

                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Seal #:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.Seal} onChange={(e) => { onChangeLoad(e, 'Seal') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>


                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Truck #:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.Truck} onChange={(e) => { onChangeLoad(e, 'Truck') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>
                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Truck Plate:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.TruckPlate} onChange={(e) => { onChangeLoad(e, 'TruckPlate') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>
                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                <InputGroup.Addon>Trailer Plate:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.TrailerPlate} onChange={(e) => { onChangeLoad(e, 'TrailerPlate') }} onInput={(e) => e.target.value = lettersNumbersDashesSpacesInputMask(e)} />
                            </InputGroup>


                        </FormGroup>
                    </Col>
                </Row>


                <Row>

                    <Col md={24} sm={24}>

                        <FormGroup >

                            <InputGroup style={{ marginBottom: '15px', width: '100%' }}>
                                <InputGroup.Addon>Notes:</InputGroup.Addon>
                                <Input defaultValue={state.NewLoadData.Notes} onChange={(e) => { onChangeLoad(e, 'Notes') }} onInput={(e) => e.target.value = limitCharacterLength(textNumbersSymbolsInputmask(e), 300)} />
                            </InputGroup>

                        </FormGroup>
                    </Col>
                </Row>


                <Row >

                    <Col md={12} sm={24}>
                        <ButtonToolbar >
                            <DebouncedButton onClick={(e) => { confirm(e, totalUnitsNumber, totalRecoveredNum, totalPalleteNum) }} buttonText="Save" block={true} />
                        </ButtonToolbar>
                    </Col>
                    <Col md={12} sm={24}>
                        <ButtonToolbar >
                            <Button block onClick={close} appearance="default">Cancel</Button>
                        </ButtonToolbar>
                    </Col>
                </Row>

            </Panel>







            {state.BuildLoadDict.map(item => (

                state.reportNav === 'pallet' ?
                    <Row >
                        <Col md={24} sm={24}>
                            <Panel bordered style={{ marginBottom: '10px' }}>

                                <Row>
                                    <Col md={8} sm={24}>
                                        Pallet Barcode: <strong>{item.PalletBarcode}</strong>
                                        <br />
                                        Warehouse Location: <strong>{item.WarehouseLocationName}</strong>
                                    </Col>

                                    <Col md={12} sm={24}>

                                        <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                            <InputGroup.Addon>Total Cases:</InputGroup.Addon>
                                            <InputNumber readOnly value={item.CasesInWhse} className={'custom-input-number'} scrollable={false} />
                                        </InputGroup>

                                        <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                            <InputGroup.Addon>Total Units:</InputGroup.Addon>
                                            <InputNumber readOnly value={item.UnitsInWhse} className={'custom-input-number'} scrollable={false} />
                                        </InputGroup>

                                    </Col>
                                    <Col md={4} sm={24}>
                                        <Button style={{ float: 'right' }} onClick={(e) => { remove(e, item) }} appearance="primary">Remove</Button>
                                        <br />
                                    </Col>
                                </Row>

                                {/* <Divider /> */}

                            </Panel>
                        </Col>
                    </Row>

                    :
                    state.reportNav === 'case' ?
                        <Row >
                            <Col md={24} sm={24}>
                                <Panel bordered style={{ marginBottom: '10px' }}>

                                    <Row>
                                        <Col md={14} sm={24}>
                                            Case Barcode: <strong>{item.CaseBarcode}</strong>
                                            <br />
                                            Pallet Barcode: <strong>{item.PalletBarcode}</strong>
                                            <br />
                                            Warehouse Location: <strong>{item.WarehouseLocationName}</strong>
                                        </Col>

                                        <Col md={6} sm={24}>

                                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                                <InputGroup.Addon>Total Units:</InputGroup.Addon>
                                                <InputNumber readOnly value={item.UnitsInWhse} className={'custom-input-number'} scrollable={false} />
                                            </InputGroup>

                                        </Col>
                                        <Col md={4} sm={24}>
                                            <Button style={{ float: 'right' }} onClick={(e) => { remove(e, item) }} appearance="primary">Remove</Button>
                                            <br />
                                        </Col>
                                    </Row>

                                    {/* <Divider /> */}

                                </Panel>
                            </Col>
                        </Row>

                        :

                        <Row >
                            <Col md={24} sm={24}>
                                <Panel bordered style={{ marginBottom: '10px' }}>

                                    <Row>
                                        <Col md={14} sm={24}>
                                            SKU: <strong>{item.SKU}</strong>
                                            <br />
                                            Case Barcode: <strong>{item.CaseBarcode}</strong>
                                            <br />
                                            Pallet Barcode: <strong>{item.PalletBarcode}</strong>
                                            <br />
                                            Warehouse Location: <strong>{item.WarehouseLocationName}</strong>
                                        </Col>

                                        <Col md={6} sm={24}>

                                            <InputGroup style={{ marginBottom: '5px', width: '100%' }}>
                                                <InputGroup.Addon>Units:</InputGroup.Addon>
                                                <InputNumber onChange={(e) => onChange(e, item, 'UnitsInWhse')} value={item.UnitsInWhse} className={'custom-input-number'} scrollable={false} />
                                            </InputGroup>

                                        </Col>
                                        <Col md={4} sm={24}>
                                            <Button style={{ float: 'right' }} onClick={(e) => { remove(e, item) }} appearance="primary">Remove</Button>
                                            <br />
                                        </Col>
                                    </Row>

                                    {/* <Divider /> */}

                                </Panel>
                            </Col>
                        </Row>

            ))}



        </div> </Drawer.Body>
        <Drawer.Footer>

            <br />

        </Drawer.Footer>
    </Drawer>
);


BuildLoadDrawer.defaultProps = {
    show: false
};

export default BuildLoadDrawer;








// {
//     item.SkuID in state.LocationDict ?

//         state.LocationDict[item.SkuID].map(locationitem => (
//             <div>
//                 <Row>
//                     <Col md={8} sm={8}>
//                         <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//                             {/* <InputGroup.Addon>Location:</InputGroup.Addon> */}
//                             <Input value={locationitem['WarehouseLocationName'] +  (locationitem['Oversize'] === true? ', Oversize' : ''   )} readOnly />
//                         </InputGroup>
//                     </Col>
//                     <Col md={5} sm={5}>
//                         <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//                             <InputGroup.Addon>Units:</InputGroup.Addon>
//                             <InputNumber value={locationitem['Units']} className={'custom-input-number'} onChange={(e) => onChangeLocation(e, item, locationitem, 'Units', locationitem['SkuWarehouseLocationID'])} scrollable={false} onInput={(e) => e.target.value = limitNumberToExistingUnitsValue(e, locationitem, item, props.SkuLocationDataGrouped)} />
//                         </InputGroup>
//                     </Col>
//                     <Col md={5} sm={5}>
//                         <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//                             <InputGroup.Addon>Cases:</InputGroup.Addon>
//                             <InputNumber value={locationitem['Cases']} className={'custom-input-number'} onChange={(e) => onChangeLocation(e, item, locationitem, 'Cases', locationitem['SkuWarehouseLocationID'])} scrollable={false} onInput={(e) => e.target.value = limitNumberToExistingValue(e, locationitem, item, props.SkuLocationDataGrouped)} />
//                         </InputGroup>
//                     </Col>
//                     <Col md={5} sm={5}>
//                         <InputGroup style={{ marginBottom: '10px', width: '100%' }}>
//                             <InputGroup.Addon>Pallets:</InputGroup.Addon>
//                             <InputNumber value={locationitem['Pallets']} className={'custom-input-number'} onChange={(e) => onChangeLocation(e, item, locationitem, 'Pallets', locationitem['SkuWarehouseLocationID'])} scrollable={false} onInput={(e) => e.target.value = numbersInputMask(e)} />
//                         </InputGroup>
//                     </Col>

//                     <Col md={1} sm={1}>

//                         <IconButton size="md" icon={<CloseIcon />} onClick={(e) => onClickRemoveFromAdd(e, item, locationitem, locationitem['SkuWarehouseLocationID'])} />

//                     </Col>

//                 </Row>
//             </div>
//         ))


//         :

//         <div></div>

// }